import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { fetchCompanyActivationList } from 'modules/companyActivation/actions';
import CompanyActivationView from 'modules/companyActivation/views/CompanyActivationView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const CompanyActivationPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();

  const companyActivationListApiCallBody = useMemo(
    () => ({
      isSelfManaged: true,
      Page: 1,
      pageSize: 10,
    }),
    [],
  );
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const body = {
      data: companyActivationListApiCallBody,
    };
    dispatch(fetchCompanyActivationList(body));

    initApp(contexts.companyActivation);
  }, [companyActivationListApiCallBody, dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <CompanyActivationView companyActivationListApiCallBody={companyActivationListApiCallBody} />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

CompanyActivationPage.propTypes = {};

CompanyActivationPage.defaultProps = {};

export default CompanyActivationPage;
